import { render } from "./InformazioniView.vue?vue&type=template&id=0c30ebd0"
import script from "./InformazioniView.vue?vue&type=script&lang=js"
export * from "./InformazioniView.vue?vue&type=script&lang=js"

import "./InformazioniView.vue?vue&type=style&index=0&id=0c30ebd0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__